export enum PartnerType
{
    Partner = 1,
    Distributor,
    Reseller,
    Hotel_Chain
}